module.exports = __webpack_public_path__ + "static/media/ма.34dd7413.mp3";